import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import AttachTagsModal, {
  AttachModalProps,
} from '@/modules/corporate/modules/tags/components/AttachTagsModal';
import { LearnerProfileActionTypes } from '@/modules/learner/views/LearnerProfile/hooks/useLearnerProfile/actions';
import { EntityTagInput, EntityTagsInput, Maybe, TagAvailableOnEnum } from '@/types/schema';

import { LearnerTagsWidgetProps } from '../LearnerTagsWidget/types';

const AVAILABLE_ON = [TagAvailableOnEnum.User];

type Props = LearnerTagsWidgetProps & { onClose: () => void; header?: AttachModalProps['header'] };

const LearnerEditTagsModal = (props: Props) => {
  const { t } = useTranslation();
  const { header, learnerId, tags, onAction, onClose } = props;

  const onSubmit = useCallback(
    async (tags?: Maybe<EntityTagsInput>) => {
      await onAction({
        type: LearnerProfileActionTypes.UpdateProfile,
        payload: { updatedValues: { userId: learnerId, tags } },
      });
      return Promise.resolve(true);
    },
    [learnerId, onAction],
  );

  return (
    <AttachTagsModal
      availableOn={AVAILABLE_ON}
      contentName={t('Common:User')}
      header={{
        title: t('Common:Actions.EditTags'),
        description: t('LearnerProfile:Tags.EditTagsDescription'),
        ...header,
      }}
      tags={tags as EntityTagInput[]}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default LearnerEditTagsModal;
